import React from "react";
import { connect } from "react-redux";
import { StyleSheet, css } from "aphrodite";

import { updateCurrentModal, getUserData } from "../actions/index";

const ButtonStyle = StyleSheet.create({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    cursor: "pointer",
    backgroundColor: "transparent"
  }
});
class RequestButton extends React.Component {
  triggerLmsModal = () => {
    this.props.currentModal("ASK_QUESTION");
  };
  render() {
    return <div className={css(ButtonStyle.container)} onClick={this.triggerLmsModal} />;
  }
}

const mapStateToProps = state => {
  return {
    all: state
  };
};

const mapDispatchToProps = dispatch => {
  return {
    currentModal: modal => dispatch(updateCurrentModal(modal)),
    getUserData: id => dispatch(getUserData(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestButton);
